import React from 'react';
import { Box} from '@mui/material';
import videoBg from '../Assets/bg008.mp4';
import useMediaQuery from '@mui/material/useMediaQuery';
import media_bg from '../Assets/Psbg.png';

function Background() {

    const matches = useMediaQuery('(min-width:1000px)');

    return (
        <Box sx={{display:'flex',backgroundOrigin:'border-box', backgroundRepeat:'no-repeat',
            backgroundPosition:'center',justifyContent:'center'}}>
                 {matches ? <video src={videoBg} autoPlay loop muted style={{
                       opacity:'0.4',             
                    objectFit:'cover',
                    position:'fixed',
                    width:'100%',
                    height:'100%',
                    zIndex:-1
                    }}/> : <img src={media_bg} style={{
                        opacity:'0.4',             
                     objectFit:'cover',
                     position:'fixed',
                     width:'100%',
                     height:'100%',
                     zIndex:-1
                     }}/>}
                    </Box>
    );
  }
  
  export default Background;